<template>
  <div class="home">
<!--    Top banner section-->
    <div class="row">
      <div class="col-lg-12 top-banner text-center">
        {{ $t('views.home.topBannerText') }}<a href="https://t.me/income_marketplace_chat" target="_blank">{{ $t('views.home.topBannerLinkText') }}</a>
      </div>
    </div>
<!--    Header laptop section-->
    <div class="container">
      <div class="row first-top-section">
        <div class="col-12 col-md-6">
          <h1>
            {{ $t('views.home.investInLoans2') }} <br/><span class="blue">{{ $t('views.home.secure') }}</span> {{ $t('views.home.and') }} <span class="blue"> {{ $t('views.home.simple') }}</span>
          </h1>
          <div class="desc">
            {{$t('views.home.topDescr')}}
          </div>
          <div>
            <get-started/>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="top-video">
            <div class="bg-laptop">
              <img v-bind:src="getSrc('top-laptop.svg')" alt="">
            </div>
            <div class="iphone">
              <img v-bind:src="getSrc('home/phone_step2.png')" alt="">
            </div>
            <div class="youtube-frame">
              <promo-video-schema></promo-video-schema>
              <video width="100%" height="295" autoplay muted loop playsinline>
                <source src="../assets/video/getincome_top.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div class="w100 app-download-section">
              <div class="d-block d-sm-block d-md-none  w-100 text-center">
                <div class="mobile-faster-header blue">{{ $t('views.home.faster') }}</div>
              </div>
            <div class="row">
              <div class="col-12 col-md-6 text-center">
                <a target="_blank" href="https://apps.apple.com/us/app/income-marketplace/id1569183737 ">
                  <img class="downapp" v-bind:src="getSrc('app/appstore.png')" alt="">
                </a>
              </div>
              <div class="col-12 col-md-6 text-center">
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.income.app">
                  <img class="downapp" v-bind:src="getSrc('app/googleplay.png')" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    Statistics section-->
    <div class="row">
      <div class="col-lg-12 income-dark">
        <div class="container">
          <div class="new-stats-values d-flex justify-content-center row" v-if="showStats">
            <div class="stat col-lg-4 col-12">
              <div class="stat-value">
                <ICountUp class="stat-value"
                          :options="{duration:3}"
                          :endVal="totalInvested"
                />
                €
              </div>
              <div class="stat-label">{{ $t('views.home.totalInvested') }}</div>
            </div>
            <div v-if="false" class="stat col-lg-3 col-12">
              <div class="stat-value">
                <ICountUp class="stat-value"
                          :options="{duration:3}"
                          :endVal="interestPaid"
                />
                €
              </div>
              <div class="stat-label">{{ $t('views.home.totalPaid') }}</div>
            </div>
            <div v-if="false" class="stat col-lg-3 col-12">
              <div class="stat-value">
                <ICountUp class="stat-value"
                          :options="{duration:3}"
                          :endVal="loansFunded"
                />
              </div>
              <div class="stat-label">{{ $t('views.home.totalLoandFunded') }}</div>
            </div>
            <div class="stat col-lg-4 col-12">
            <div class="stat-value">
              <ICountUp class="stat-value"
                        :endVal="averageAnnual"
                        :options="{decimalPlaces: 2, duration:3}"
              />
              %
            </div>
            <div class="stat-label">{{ $t('views.home.averageAnnual') }}</div>
            </div>
            <div class="stat col-lg-4 col-12">
            <div class="stat-value">
              <ICountUp class="stat-value"
                        :options="{duration:3}"
                        :endVal="approvedInvestorsCount"
              />
            </div>
            <div class="stat-label">{{ $t('views.home.totalApprovedInvestors') }}</div>
              </div>
          </div>
        </div>
      </div>
    </div>

<!--    Founded in section-->
    <div class="col-lg-12 ">
      <div class="container founded">
        <div class="row">
          <div class="col-12">
              <div class="our-promise">
                <h2><span class="blue">{{ $t('views.home.whyInvestInLooans') }}</span></h2>
                <div>
                  <div class="description">
                    {{ $t('views.home.loansAreAnAttractive') }}
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="container info-data">
          <div class="row">
            <div class="col-12 col-md-4 col-lg-4 col-xl-4">
              <div class="info-value">
                {{ $t('views.home.buildYourWealth') }}
              </div>
              <div class="desc">
                {{ $t('views.home.easyAndSecuredInvestm') }}</div>
            </div>
            <div class="col-12 col-md-4 col-lg-4 col-xl-4">
              <div class="info-value">{{ $t('views.home.securedInvestments') }}</div>
              <div class="desc">{{ $t('views.home.incomeOffersInvest') }}</div>
            </div>
            <div class="col-12 col-md-4 col-lg-4 col-xl-4 last">
              <div class="info-value">{{ $t('views.home.financialTransparency') }}</div>
              <div class="desc">{{ $t('views.home.investingInLoans') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    Trusted by / Media section-->
    <div class="row">
      <div class="col-lg-12 growth">
        <div class="row text-center articles-links">
          <div v-if="false" class="col-12 header-links">
            {{ $t('views.home.incomeInTheMedia') }}
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://www.crowdfundinsider.com/2021/08/178808-tallinns-fintech-income-finalizes-seed-round-led-by-tolaram-fintech-a-unit-of-singapore-based-firm/" target="_blank"
               rel="nofollow noopener">
              <img class="toplogo" src="../assets/media/crowdfundinsider.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://explorep2p.com/income-marketplace/" target="_blank" rel="nofollow noopener">
              <img class="toplogo top-pad10" src="../assets/media/explorep2p.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://thefintechtimes.com/income-launches-in-europe-with-next-generation-of-p2p-loan-financing/" target="_blank" rel="nofollow noopener">
              <img class="oi top-pad" src="../assets/media/fintechtimes.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
          <a href="https://passives-einkommen-mit-p2p.de/income-erfahrungen/" target="_blank" rel="nofollow noopener">
            <img class="oi top-pad" src="../assets/media/pass_ein.png" alt=""/>
          </a>
        </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://todocrowdlending.com/income/kimmo-22/" target="_blank" rel="nofollow noopener">
              <img class="toplogo  top-pad10" src="../assets/media/todo-crowdl.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://p2pmarketdata.com/income-marketplace-interview-ceo-kimmo-rytkonen/" target="_blank" rel="nofollow noopener">
              <img class="toplogo top-pad10" src="../assets/media/p2pMarketData.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://p2pempire.com/en/review/income" target="_blank" rel="nofollow noopener">
              <img class="toplogo top-pad10" src="../assets/media/p2pEmpire.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://p2pplatforms.com/income-marketplace-review/" target="_blank" rel="nofollow noopener">
              <img class="oi" src="../assets/media/p2pplatforms.png" alt=""/>
            </a>
          </div>
          <div class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
            <a href="https://finance.yahoo.com/news/estonian-startup-income-announces-funding-093000216.html" target="_blank" rel="nofollow noopener">
              <img class="toplogo  top-pad10" src="../assets/media/yahoo_finance.png" alt=""/>
            </a>
          </div>
        </div>
      </div>
    </div>

<!--    Phone sliders section-->
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <h2 class="hiw">{{ $t('navbar.howItWorks') }}?</h2>
            <div class="phone-section row">
              <div class="top-part col-12 col-md-6" id="stick-top-trigger-1">
                <div id="stick-photo-1" class="phone">
                  <div class="phone-context">
                    <h2 id="stick-description-header">
                      1. {{ $t('views.home.step.one') }}
                    </h2>
                    <img id="stick-photo1" v-bind:src="getSrc('home/phone_step1.png')" alt="">
                    <img id="stick-photo2" v-bind:src="getSrc('home/phone_step2.png')" alt="">
                    <img id="stick-photo3" v-bind:src="getSrc('home/phone_step3.png')" alt="">
                    <img id="stick-photo4" v-bind:src="getSrc('home/phone_step4.png')" alt="">
<!--                    <img id="stick-photo2" v-bind:src="getSrc('iPhone_ 12Pro.png')" alt="">-->
<!--                    <img id="stick-photo3" v-bind:src="getSrc('iPhone_ 12Pro.png')" alt="">-->
<!--                    <img id="stick-photo4" v-bind:src="getSrc('iPhone_ 12Pro.png')" alt="">-->
                  </div>
                </div>
              </div>
              <div class="part-1 col-12 col-md-6">
              </div>
              <div id="stick-trigger-1" class="trigger col-12 col-md-6">
                <div class="details" id="stick-description-1">
                  <h3>{{ $t('views.home.step.one') }}</h3>
                  <div class="descr">
                    <p>{{ $t('views.home.step.oneDescr') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="part-2 col-12 col-md-6">
                  <div id="stick-photo-2" class="phone">
<!--                    <h2 id="stick-description&#45;&#45;header-2">2. Add funds</h2>-->
<!--                    <img style="transform: translate(20px, 10px) rotate(10deg);" v-bind:src="getSrc('iPhone_ 12Pro.png')" alt="">-->
                  </div>
                </div>
              <div id="stick-trigger-2" class="trigger col-12 col-md-6">
                <div class="details" id="stick-description-2">
                <h3>{{ $t('views.home.step.two') }}</h3>
                <div class="descr">
                  <p>{{ $t('views.home.step.twoDescr') }}
                  </p>
                </div>
                </div>
              </div>

              <div id="stick-trigger-3" class="part-3 col-12 col-md-6">
                <div id="stick-photo-3" class="phone">
<!--                  <h2 id="stick-description&#45;&#45;header-3">3. Invest</h2>-->
<!--                  <img style="transform: translate(30px, 20px) rotate(30deg);" v-bind:src="getSrc('iPhone_ 12Pro.png')" alt="">-->
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="details" id="stick-description-3">
                  <h3>{{ $t('views.home.step.three') }}</h3>
                <div class="descr">
                  <p>{{ $t('views.home.step.threeDescr') }}
                  </p>
                </div>
                </div>
              </div>

              <div id="stick-trigger-4" class="part-4 col-12 col-md-6">
                <div id="stick-photo-4" class="phone">
<!--                  <h2 id="stick-description&#45;&#45;header-4">4. Get Income</h2>-->
<!--                  <img style="transform: translate(50px, 40px) rotate(60deg);"  v-bind:src="getSrc('iPhone_ 12Pro.png')" alt="">-->
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="details" id="stick-description-4">
                  <h3>{{ $t('views.home.step.four') }}</h3>
                <div class="descr">
                  <p>{{ $t('views.home.step.fourDescr') }}
                  </p>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    Start investing today section-->
    <div v-if="false" class="container">
      <div class="row">
        <div class="col-lg-12 home-start-investing">
          <h2>{{ $t('views.home.startInvestingToday') }}</h2>
          <div class="detail-info">{{ $t('views.home.earnUpTo1') }}</div>
          <get-started/>
        </div>
      </div>
    </div>

    <div>
      <b-modal
          centered
          v-model="showChristmas"
          size="lg"
          hide-footer
          @hide="hideChristmas"
      >
        <template #modal-header="{ close }">
          <div class="w-100 modal-header-top"></div>
          <b-button size="sm" variant="outline" @click="close()">X</b-button>
        </template>
        <div class="mcr-main">
          <div class="mcr-body">
            <div class="mcr-logo"><img src="../assets/christmas_bg.png" alt="Income"></div>
            <h1 class="w-100 text-center">{{ $t('views.home.merryChristmas') }}</h1>
            <h2 class="w-100 text-center">{{ $t('views.home.weAreOpen') }}</h2>
            <h5 class="w-100 text-center">{{ $t('views.home.thisMeansYou') }}</h5>
          </div>
        </div>
      </b-modal>
      <login-error-modal v-if="showLoginError" :error="loginError"/>
    </div>
  </div>
</template>

<script>
import HomepageHeader from '../components/HomepageHeader'
import GetStarted from '../components/GetStarted'
import HomeSchema from '@/schema/HomeSchema'
import localStorageHelper from '@/helpers/localStorageHelper'
import imageMixin from '@/mixins/image'
import LoginErrorModal from '@/components/LoginErrorModal'
import PromoVideoSchema from '@/schema/PromoVideoSchema'
import ICountUp from 'vue-countup-v2'
import Statistics from '../api/statistics'
import VueScrollmagic from 'vue-scrollmagic'
import Vue from 'vue'
Vue.use(VueScrollmagic)

export default {
  name: 'Home',
  components: {
    PromoVideoSchema,
    LoginErrorModal,
    GetStarted,
    HomepageHeader,
    HomeSchema,
    ICountUp
  },
  mixins: [imageMixin],
  data()
  {
    return {
      showChristmas: false,
      showLoginError: false,
      loginError: null,
      totalInvested: 3050000,
      interestPaid: 2100000,
      loansFunded: 100000,
      averageAnnual: 13.78,
      approvedInvestorsCount: 1042,
      showStats: true
    }
  },
  mounted: function ()
  {
    if (window.screen.availWidth > 768)
    {
      const duration = 275
      const photoDuration = 400

      const scenePhoto1 = this.$scrollmagic.scene({
        triggerElement: '#stick-top-trigger-1',
        // {0,0.5,1} - animations starts from {top,center,end} of window
        triggerHook: 0.2,
        offset: -50,
        duration: 2550
      }).setPin('#stick-photo-1')
      this.$scrollmagic.addScene(scenePhoto1)

      const scenePhoto2 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-2',
        triggerHook: 0,
        offset: -50,
        duration: photoDuration
      }).setPin('#stick-photo-2')
      this.$scrollmagic.addScene(scenePhoto2)

      const scenePhoto3 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-3',
        triggerHook: 0,
        offset: -50,
        duration: photoDuration
      }).setPin('#stick-photo-3')
      this.$scrollmagic.addScene(scenePhoto3)

      const scenePhoto4 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-4',
        triggerHook: 0,
        offset: -50,
        duration: photoDuration
      }).setPin('#stick-photo-4')
      this.$scrollmagic.addScene(scenePhoto4)

      const scene1 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-1',
        // {0,0.5,1} - animations starts from {top,center,end} of window
        triggerHook: 0.5,
        offset: 0,
        duration: 350
      }).setPin('#stick-description-1')

      // scene1.setClassToggle('#stick-description-1', 'tada')
      // scene1.setClassToggle('#stick-description-1', 'zoomIn')

      // eslint-disable-next-line no-inner-declarations
      function updateHeader(number, text, direction = 'FORWARD')
      {
        const header = document.getElementById('stick-description-header')
        if (header)
        {
          header.innerHTML = text
          // Animation here. Up/down show hide
          const showSpeed = 50
          const hideSpeed = 220
          const stickPhoto = document.getElementById('stick-photo' + number)
          const stickPhoto1 = document.getElementById('stick-photo1')
          const stickPhoto2 = document.getElementById('stick-photo2')
          const stickPhoto3 = document.getElementById('stick-photo3')
          const stickPhoto4 = document.getElementById('stick-photo4')
          // stickPhoto.classList.remove('fadeInLeft')
          // stickPhoto.classList.add('fadeInRight')

          // console.log(number, ' -> ', direction)
          // stickPhoto.classList.remove('fadeOutRight')
          // stickPhoto.classList.add('fadeInLeft')
          if (direction === 'FORWARD')
          {
            stickPhoto.classList.remove('fadeOutLeft')
            stickPhoto.classList.remove('fadeInRight')
            stickPhoto1.classList.remove('fadeOutLeft')
            stickPhoto1.classList.remove('fadeInRight')
            stickPhoto2.classList.remove('fadeOutLeft')
            stickPhoto2.classList.remove('fadeInRight')
            stickPhoto3.classList.remove('fadeOutLeft')
            stickPhoto3.classList.remove('fadeInRight')
            stickPhoto4.classList.remove('fadeOutLeft')
            stickPhoto4.classList.remove('fadeInRight')
            switch (number)
            {
              case 1:
                setTimeout(() =>
                {
                  stickPhoto3.classList.add('fadeOutRight')
                  stickPhoto4.classList.add('fadeOutRight')
                  stickPhoto2.classList.add('fadeOutRight')
                }, hideSpeed)
                break
              case 2:
                setTimeout(() =>
                {
                  stickPhoto2.classList.remove('fadeOutRight')
                  stickPhoto2.classList.add('fadeInLeft')
                  stickPhoto2.style.display = 'inline-block'
                }, showSpeed)
                setTimeout(() =>
                {
                  stickPhoto1.classList.add('fadeOutRight') // down
                  stickPhoto3.classList.add('fadeOutRight')
                  stickPhoto4.classList.add('fadeOutRight')
                }, hideSpeed)
                break
              case 3:
                setTimeout(() =>
                {
                  stickPhoto3.classList.remove('fadeOutRight')
                  stickPhoto3.classList.add('fadeInLeft')
                  stickPhoto3.style.display = 'inline-block'
                }, showSpeed)
                setTimeout(() =>
                {
                  stickPhoto2.classList.add('fadeOutRight')
                  stickPhoto1.classList.add('fadeOutRight')
                  stickPhoto4.classList.add('fadeOutRight')
                  stickPhoto2.classList.remove('fadeInLeft')
                }, hideSpeed)
                break
              case 4:
                setTimeout(() =>
                {
                  stickPhoto4.classList.remove('fadeOutRight')
                  stickPhoto4.classList.add('fadeInLeft')
                  stickPhoto4.style.display = 'inline-block'
                }, showSpeed)
                setTimeout(() =>
                {
                  stickPhoto3.classList.add('fadeOutRight')
                  stickPhoto2.classList.add('fadeOutRight')
                  stickPhoto1.classList.add('fadeOutRight')
                  stickPhoto3.classList.remove('fadeInLeft')
                }, hideSpeed)
                break
            }
            // stickPhoto.src = img
          }
          else
          {
            stickPhoto.classList.remove('fadeInLeft')
            stickPhoto.classList.remove('fadeOutRight')
            stickPhoto1.classList.remove('fadeInLeft')
            stickPhoto1.classList.remove('fadeOutRight')
            stickPhoto2.classList.remove('fadeInLeft')
            stickPhoto2.classList.remove('fadeOutRight')
            stickPhoto3.classList.remove('fadeInLeft')
            stickPhoto3.classList.remove('fadeOutRight')
            stickPhoto4.classList.remove('fadeInLeft')
            stickPhoto4.classList.remove('fadeOutRight')
            switch (number)
            {
              case 3:
                setTimeout(() =>
                {
                  stickPhoto3.classList.remove('fadeOutLeft')
                  stickPhoto3.classList.add('fadeInRight')
                  stickPhoto3.style.display = 'inline-block'
                }, showSpeed)
                setTimeout(() =>
                {
                  stickPhoto1.classList.add('fadeOutLeft')
                  stickPhoto2.classList.add('fadeOutLeft')
                  stickPhoto4.classList.add('fadeOutLeft')
                }, hideSpeed)
                break
              case 2:
                setTimeout(() =>
                {
                  stickPhoto2.classList.remove('fadeOutLeft')
                  stickPhoto2.classList.add('fadeInRight')
                  stickPhoto2.style.display = 'inline-block'
                }, showSpeed)
                setTimeout(() =>
                {
                  stickPhoto3.classList.add('fadeOutLeft')
                  stickPhoto1.classList.add('fadeOutLeft')
                  stickPhoto4.classList.add('fadeOutLeft')
                  stickPhoto3.classList.remove('fadeInRight')
                }, hideSpeed)
                break
              case 1:
                stickPhoto4.style.display = 'none'
                stickPhoto3.style.display = 'none'
                setTimeout(() =>
                {
                  stickPhoto1.classList.remove('fadeOutLeft')
                  stickPhoto1.style.display = 'inline-block'
                  stickPhoto1.classList.add('fadeInRight')
                }, showSpeed)
                setTimeout(() =>
                {
                  stickPhoto4.classList.add('fadeOutLeft')
                  stickPhoto3.classList.add('fadeOutLeft')
                  stickPhoto2.classList.remove('fadeInRight')
                  stickPhoto2.classList.add('fadeOutLeft')
                }, hideSpeed)
                break
            }
          }
        }
      }

      scene1.header = '1. ' + this.$t('views.home.step.one')
      scene1.on('enter ', function (e)
      {
        updateHeader(1, this.header, e.scrollDirection)
        document.querySelector('.top-part')?.classList.add('fadeIn')
        document.querySelector('.top-part')?.classList.remove('fadeOut')
        document.querySelector('.part-1')?.classList.add('fadeIn')
        document.querySelector('.part-1')?.classList.remove('fadeOut')
        document.querySelector('#stick-description-1')?.classList.add('fadeIn')
      })

      // scene1.addIndicators('PART1 - section ')
      this.$scrollmagic.addScene(scene1)

      const scene2 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-2',
        triggerHook: 0.5,
        offset: 100,
        duration: duration
      })
          .setPin('#stick-description-2')
      // .setClassToggle('#stick-description-2', 'tada')
      scene2.header = '2. ' + this.$t('views.home.step.two')
      scene2.on('enter', function (e)
      {
        updateHeader(2, this.header, e.scrollDirection)
        document.querySelector('.part-1')?.classList.add('fadeOut')
        document.querySelector('.part-2')?.classList.remove('fadeOut')
        document.querySelector('.part-2')?.classList.add('fadeIn')
        document.querySelector('#stick-description-2')?.classList.add('fadeIn')
      })

      this.$scrollmagic.addScene(scene2)

      const scene3 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-3',
        triggerHook: 0.5,
        offset: 100,
        duration: duration
      })
          .setPin('#stick-description-3')
      // .setClassToggle('#stick-description-3', 'slideInLeft')
      scene3.header = '3. ' + this.$t('views.home.step.three')
      scene3.on('enter ', function (e)
      {
        updateHeader(3, this.header, e.scrollDirection)
        document.querySelector('.part-2')?.classList.add('fadeOut')
        document.querySelector('.part-3')?.classList.remove('fadeOut')
        document.querySelector('.part-3')?.classList.add('fadeIn')
        document.querySelector('#stick-description-3')?.classList.add('fadeIn')
      })
      this.$scrollmagic.addScene(scene3)

      const scene4 = this.$scrollmagic.scene({
        triggerElement: '#stick-trigger-4',
        triggerHook: 0.5,
        offset: 100,
        duration: duration
      })
          .setPin('#stick-description-4')
      // .setClassToggle('#stick-description-4', 'zoomIn')
      scene4.header = '4. ' + this.$t('views.home.step.four')
      scene4.on('enter ', function (e)
      {
        updateHeader(4, this.header, e.scrollDirection)
        document.querySelector('.part-3')?.classList.add('fadeOut')
        document.querySelector('.part-4')?.classList.add('fadeIn')
        document.querySelector('.part-4')?.classList.remove('fadeOut')
        document.querySelector('#stick-description-4')?.classList.add('fadeIn')
      })

      this.$scrollmagic.addScene(scene4)
    }
    const loginError = localStorageHelper.get('loginError')
    if (loginError)
    {
      // TODO: need to be removed. deprecated for new auth
      // this.showLoginError = true
      // let errorHeading = loginError
      // let errorText = ''
      // let btnText = this.$t('views.home.continueBtn')
      // const errorImg = 'mail.svg'
      // if (loginError === 'unauthorized')
      // {
      //   errorHeading = this.$t('views.home.verifyTitle')
      //   errorText = '<span class="text-larger">' + this.$t('views.home.errorTextWeHaveSent1') + '</span><br/>' + this.$t('views.home.errorTextWeHaveSent2')
      //   btnText = this.$t('views.home.gotit')
      // }
      // this.loginError = {
      //   heading: errorHeading,
      //   text: errorText,
      //   btnText: btnText,
      //   img: errorImg
      // }
      localStorageHelper.remove('loginError')
    }
    /* if (!this.$cookie.get('auth0.is.authenticated'))
    {
      this.showChristmas = !this.$cookie.get('CookieChristmas2021')
    }
     */
    if (!this.$cookie.get('statsTotalInvested'))
    {
      Statistics.get().then((response) =>
      {
        if (response.overview && response.average_earning)
        {
          this.averageAnnual = parseFloat(response.average_earning)
          if (response.approved_investors)
          {
            this.approvedInvestorsCount = parseFloat(response.approved_investors)
          }
          let totalInvested = 0
          let totalPaid = 0

          if (response.loans_funded)
          {
            this.loansFunded = parseFloat(response.loans_funded)
          }

          response.overview.forEach((overviewItem) =>
          {
            totalInvested += parseFloat(overviewItem.invested_on_platform_all_time)
            totalPaid += parseFloat(overviewItem.total_paid_to_investors)
          })
          this.totalInvested = totalInvested
          this.interestPaid = totalPaid
          this.$cookie.set('statsTotalInvested', totalInvested, {expires: '1h'})
          this.$cookie.set('statsTotalPaid', totalPaid, {expires: '1h'})
          this.$cookie.set('statsAverageAnnual', this.averageAnnual, {expires: '1h'})
          this.$cookie.set('statsApprovedInvestorsCount', this.approvedInvestorsCount, {expires: '1h'})
          this.showStats = true
        }
        else
        {
          console.log('Something wrong with response data and structure')
        }
      }).catch((error) =>
      {
        console.error(error)
      })
    }
    else
    {
      this.totalInvested = parseFloat(this.$cookie.get('statsTotalInvested'))
      this.interestPaid = parseFloat(this.$cookie.get('statsTotalPaid'))
      this.averageAnnual = parseFloat(this.$cookie.get('statsAverageAnnual'))
      this.approvedInvestorsCount = parseFloat(this.$cookie.get('statsApprovedInvestorsCount'))
      this.showStats = true
    }
  },
  methods: {
    hideChristmas()
    {
      this.$cookie.set('CookieChristmas2021', true)
      this.showChristmas = false
    }
  }
}
</script>

<style scoped lang="scss">
.growth {
  overflow: hidden;
}
//.growth {
//  background-image: url("../assets/bg-growth.png");
//  background-size: 100%;
//  background-position: right 155px;
//  background-repeat: no-repeat;
//}

.home-world-map {
  margin-top: 35px;
  margin-bottom: 35px;
}

.home-laptop {
  height: 100%;
  padding: 10px;
  width: 100%;

  .laptop {
    float: left;

    img {
      max-width: 868.51px;
      max-height: 513.83px;
      width: 100%;
    }
  }

  .stats-values {
    margin-top: 83px;
    float: left;
    margin-left: -190px;

    .stat-value {
      color: #30a7fe;
      font-size: 44px;
      font-weight: bold;
      line-height: 45px;
    }

    .stat-label {
      color: #babbbb;
      font-size: 20px;
    }
  }
}

.home-money-grow {
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;

  h2 {
    margin-top: 50px;
    margin-bottom: 40px;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
  }

  img {
    max-width: 642px;
    width: 100%;
    margin-bottom: 35px;
  }
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .start-investing-img {
    margin-bottom: 40px;
    width: 100%;
    max-width: 590px;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.money-description {
  font-size: 21px;
  line-height: 28px;
  text-align: center;
  color: #9DA0A6;
  margin-bottom: 25px;
}

.invest-steps {
  text-align: center;
  margin-right: 10%;

  .list {
    text-align: left;
    list-style: none;
    display: inline-block;
  }

  .step-number {
    border: 5px solid #30A7FE;
    margin: 4px;
    border-radius: 15px 4px 4px 20px;
    background: #30A7FE;
    padding: 2px;
    color: white;
  }
}

.intro-text {
  display: inline-block;
  width: 100%;
  text-align: center;
}

.our-promise {
  text-align: left;
  margin-bottom: 15px;

  h2 {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 87px;
    margin-bottom: 50px;
    margin-top: 20px;
  }

  div {
    margin-bottom: 10px;
  }

  .description{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: #000000;
    margin-bottom: 80px;
  }
}

.info-data {
  .info-img {
    text-align: center;
    margin-top: 25px;
    margin-bottom: 1px;

    img {
      height: 30px;
    }
  }

  .last{
    margin-top: -30px;
  }

  .info-value {
    font-style: normal;
    text-align: left;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 41px;
    color: #000000;
    margin-bottom: 25px;
  }

  .desc {
    font-style: normal;
    text-align: left;
    margin-bottom: 50px;
    margin-top: 15px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 140%;
    letter-spacing: 0.1em;
    color: rgba(7, 29, 45, 0.8);
  }
}

.island {
  background-image: url("../assets/island.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  min-height: 350px;

  .photo {
    margin-top: 65px;
    margin-bottom: 35px;
    width: 100%;
    max-width: 580px;
  }
}

.founded {
  margin-top: 50px;
  margin-bottom: 50px;

  .left-section {
    .our-promise {
      h2 {
        font-weight: bold;
        font-size: 35px;
        line-height: 40px;
        margin-top: 15px;
        text-align: justify;
      }

      .description {
        font-size: 16px;
        line-height: 24px;
        color: #6E777A;
        margin-top: 50px;
      }
    }
  }
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .bg-column {
    background-image: url("../assets/ballons-left.png");
    background-position: left 0;
    background-repeat: no-repeat;
    background-size: contain;
    min-height: 255px;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
    display: inline-block;
  }

  .circle {
    background: #EC4C60;
    border-radius: 108px;
    border: 3px solid #EC4C60;
    font-weight: bold;
    text-align: center;
    color: #FFFFFF;
    font-style: normal;
    padding-top: 61px;
    padding-bottom: 61px;
    margin: 27% 0 0 57%;
    font-size: 22px;
    line-height: 30px;
    max-width: 220px;
  }

  .text {
    margin-top: 25px;
    margin-bottom: 45px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 14px;
      font-size: 14px;
      line-height: 24px;
      color: #6E777A;
    }
  }
}

.toplogo {
  max-width: 160px;
}

.oi {
  margin-right: 20px;
  margin-left: 20px;
  max-width: 195px;
  margin-bottom: 15px;
  margin-top: 10px;
  max-height: 60px;
}

.top-pad {
  padding-top: 20px;
}

.top-pad10 {
  padding-top: 10px;
}

.articles-links {
  margin-bottom: 80px;
}

.additional-header {
  margin-top: 5px;
  font-weight: bold;
  text-align: center;
  color: #6E777A;
}

.mcr-main {
  h1, h2, h5 {
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
  }

  .mcr-logo img {
    width: 100%;
  }
}

.header-links {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 87px;
  color: #30A7FE;
  display: block;
  margin-bottom: 16px;
  margin-top: 25px;
}

.downapp {
  max-width: 171px;
  margin-bottom: 7px;
}

.mobile-faster-header {
  font-weight: bold;
  font-size: 20px;
  margin-top: 15px;
  margin-bottom: 5px;
}

.applink {
  margin-left: 8px;
}

.aps {
  margin-right: 8px;
}

.top-banner {
  background: #30A7FE;
  color: #FFFFFF;
  padding-top: 15px;
  padding-bottom: 15px;
  box-shadow: 2px 2px 2px #30A7FE;
  font-weight: bold;
  font-size: 20px;
  font-family: 'Open Sans', sans-serif;
  margin-top: -9px;
  opacity: 0.7;
  filter: alpha(opacity=70);

  a {
    color: #FFFFFF;
    padding-left: 10px;
    text-decoration: underline;
  }
}

@media (max-width: 1200px) {
  .equal-opportunity {
    .text {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
}

@media (max-width: 994px) {
  .equal-opportunity {
    .text {
      margin-bottom: 10px;
      margin-top: 10px;
    }

    .info {
      line-height: 19px !important;
    }
  }
}

@media (max-width: 765px) {
  .equal-opportunity {
    .circle {
      margin: 15px auto auto auto;
    }

    .text {
      margin-bottom: 30px;
      margin-top: 30px;
    }
  }
  .col-video {
    padding: 0;
  }
}

@media (max-width: 1224px) {
  .home-laptop .stats-values {
    margin-top: 90px;
    float: none !important;
    margin-left: auto !important;
    text-align: center;
  }
}

//New redesign 2022 section
.first-top-section {
  margin-top: 100px;
  margin-bottom: 100px;

  h3, h1{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 58px;
    line-height: 80px;
  }

  .desc{
    margin-top: 50px;
    margin-bottom: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: #000000;
  }

  .app-download-section{
    margin-top: 50px;
  }

  .bg-laptop{
    position:absolute;
    z-index:-1;
    img {
      max-width: 100%;
      @media screen and (max-width: 520px) {
        display: none;
      }
    }
  }

  .iphone{
    position: absolute;
    margin-top: 170px;
    margin-left: 25px;
    img{
      max-height: 150px;
    }
    @media screen and (min-width: 991px) and (max-width: 1198px) {
      margin-top: 143px;
      img{
        max-height: 120px;
      }
    }
    @media screen and (min-width: 768px) and (max-width: 990px) {
      margin-top: 103px;
      img{
        max-height: 95px;
      }
    }
    @media screen and (min-width: 520px) and (max-width: 767px) {
      margin-top: 150px;
      img{
        max-height: 140px;
      }
    }
    @media screen and (max-width: 520px) {
      display: none;
    }
  }

  .youtube-frame{
    text-align: center;
    video{
      width: 444px;
      height: 292px;
      border-radius: 10px;
      margin-top: 3px;
      margin-left: 16px;
      @media screen and (min-width: 991px) and (max-width: 1198px) {
        width: 375px;
        height: 240px;
      }
      @media screen and (min-width: 767px) and (max-width: 990px) {
        width: 277px;
        height: 178px;
      }
      @media screen and (min-width: 520px) and (max-width: 767px) {
        width: 420px;
        height: 275px;
      }
      @media screen and (max-width: 520px) {
        margin-left: 0;
        width: 100%;
      }
    }
  }
}

.phone-section {
  margin-bottom: 20px;
  margin-top: 20px;

  .details{
    opacity: 0.5;
    margin-bottom: 200px;
    @media screen and (max-width: 768px) {
      margin-bottom: 50px;
      opacity: 1;
    }
  }

  .trigger{
  }

  .phone {
    //background: #2E9FF2;
    //border-radius: 40px 40px 45px 45px;
    margin: 10px;
    padding-bottom: 20px;
    min-height: 400px;
    overflow: hidden;
    // border: 1px solid #c3c3c3;
    @media screen and (max-width: 768px) {
      min-height: 25px;
    }
    img{
      height: 450px;
    }

    h2{
      color: white;
      font-size: 34px;
      //text-shadow:  1px 1px 2px #0C2D45;
    }
  }

  h3 {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 40px;
    display: flex;
    align-items: center;
    color: #30A7FE;
    margin-bottom: 20px;
    justify-content: start;
    text-align: left;
  }

  .descr {
    text-align: left;
    margin: 10px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;
    letter-spacing: 0.1em;
    color: rgba(7, 29, 45, 0.8);
  }

  .part-1, .part-2, .part-3, .part-4  {
    opacity: 0.5;
  }
}

.top-part{
  position: absolute;
  opacity: 0.5;
  @media screen and (max-width: 780px) {
    opacity: 1;
    display: none;
  }

  .phone-context{
    background: #2E9FF2;
    border-radius: 40px 40px 45px 45px;
    padding-bottom: 20px;
    height: 550px;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;

    h2 {
      position: absolute;
      top: 1px;
    }

    img{
      margin-top: 70px;
    }
  }
}

#stick-description-header, #stick-photo1, #stick-photo2 , #stick-photo3 , #stick-photo4{
  transition: all 2s ease-in-out;
  position: absolute;
}

#stick-photo2 , #stick-photo3 , #stick-photo4{
  display: none;
}

.hiw{
  margin-bottom: 50px;
}

.income-dark{
  background: #0C2D45;

  .new-stats-values{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    color: #FFFFFF;
    margin-top: 30px;
    margin-bottom: 30px;

    .stat-value{
      font-size: 45px;
      font-width: 500;
      line-height: 46px;
      margin-bottom: 10px;
    }

    .stat-label{
      font-size: 18px;
      font-weight: 600;
      line-height: 14px;
      text-align: center;
      letter-spacing: 0.5px;
      @media screen and (max-width:980px) {
        margin-bottom: 25px;
      }
    }
  }
}

// Animations
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeIn {
  0% {opacity: 0.5;}
  100% {opacity: 1;}
}
@keyframes fadeIn {
  0% {opacity: 0.5;}
  100% {opacity: 1;}
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeOut {
  0% {opacity: 1;}
  100% {opacity: 0.5;}
}
@keyframes fadeOut {
  0% {opacity: 1;}
  100% {opacity: 0.5;}
}

.tada {
  -webkit-animation-name: tada;
  animation-name: tada;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes tada {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
  }
  30%, 50%, 70%, 90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }
  40%, 60%, 80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes tada {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
  }
  30%, 50%, 70%, 90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }
  40%, 60%, 80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.slideInLeft {
  -webkit-animation-name: slideInLeft;
  animation-name: slideInLeft;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(.3, .3, .3);
    transform: scale3d(.3, .3, .3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(.3, .3, .3);
    transform: scale3d(.3, .3, .3);
  }
  50% {
    opacity: 1;
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeOutRight {
  -webkit-animation-name: fadeOutRight;
  animation-name: fadeOutRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeOutRight {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
@keyframes fadeOutRight {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown;
  animation-name: fadeOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeOutDown {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}
@keyframes fadeOutDown {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeOutLeft {
  -webkit-animation-name: fadeOutLeft;
  animation-name: fadeOutLeft;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeOutLeft {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes fadeOutLeft {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

[lang="et"] {
  .our-promise {
    h2 {
      font-size: 44px;
      line-height: 47px;
    }
  }
  .phone-section h3{
    font-size: 44px;
    line-height: 47px;
  }
}

.phone-section h3{
  @media (max-width: 768px) {
    font-size: 44px;
    line-height: 47px;
  }
}
</style>
